(function () {
    const quickExit = document.querySelectorAll('.quick-exit');

    if (
        quickExit.length > 0 &&
        document.querySelectorAll('.quick-exit__button').length > 0
    ) {
        const quickExitFunc = function (site) {
            // then redirect to a non-sensitive site
            window.open(site, '_blank');
            window.location.replace(site);

            // remove as much info from URL as possible
            if (window.history) {
                try {
                    window.history.replaceState({}, '', '/');
                } catch (e) {
                    console.log('no');
                }
            }

            // disable default event handling
            return false;
        };
        const quickExitInit = function () {
            const button = document.querySelector('.quick-exit__button');
            const escapeSite = 'https://www.google.com.au/';
            const hotkey = 27;

            // add click handler
            button.onclick = function () {
                return quickExitFunc(escapeSite);
            };

            // load a plugin only on IE browser to support position:sticky
            if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
                // stickyfill.add(document.querySelector('.quick-exit'));
            }

            // add hotkey trigger
            document.addEventListener('keydown', function (e) {
                if (e.keyCode === hotkey) {
                    quickExitFunc(escapeSite);

                    if (e) {
                        // stop escape from cancelling redirect
                        e.preventDefault();

                        // early IEs don't have preventDefault
                        e.returnValue = false;
                    }

                    return false;
                }
                return false;
            });
        };

        quickExitInit();
    }
})();
